<script>
export default {
  name: 'ReCaptchaErrorDialog',
};
</script>

<template>
  <v-dialog model-value="true"
            persistent
            scrollable
            :fullscreen="$vuetify.display.xs"
            :width="$vuetify.display.smAndUp ? 600 : 'auto'"
            style="z-index: 1100 !important;"
  >
    <v-card>
      <v-card-title class="bg-error pa-3">
        {{ $t("dialogs.recatpcha_error.title") }}
      </v-card-title>

      <v-card-text class="pa-5 text-body-1 d-flex flex-row align-center">
        <div class="pl-2 pr-2">
          <v-icon color="red" size="x-large">mdi-alert</v-icon>
        </div>
        <div class="pl-2 pr-2">
          <div class="pb-2">
            {{ $t("dialogs.recatpcha_error.body-p1") }}
          </div>
          {{ $t("dialogs.recatpcha_error.body-p2") }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
